import React, { useState, useRef } from 'react'; 
import { 
  Grid,
  GridColumn,
  Button,
  Image,
  Container,
} from 'semantic-ui-react';

export default function Gallery(props) {
  const allImages = [
    { src: 'macrocarpaPineBlueResinDiningTable.webp', alt: 'Macrocarpa pine and blue resin dining table (3.2 metres long)' },
    { src: 'huonPineBlueResinTimberClock.webp', alt: 'Huon Pine skeleton clock' },
    { src: 'huonPinePurpleResinTimberBoards.webp', alt: 'Huon pine & purple resin tray, lazy susan & serving board' },
    { src: 'huonPineRedResinTimberLamp.webp', alt: 'Huon pine & resin lamp with Californian redwood base' },
    { src: 'blackwoodButchersBlock.webp', alt: 'Blackwood butchers block' }, 
    { src: 'blackheartSassafrasRedWineResinCoffeeTable.webp', alt: 'Blackheart sassafras & red wine resin inlaid with wine bottle corks' },
    { src: 'myrtleBlueResinCoffeeTable.webp', alt: 'Myrtle & blue resin inlaid with wine bottle corks' }, 
    { src: 'huonPineBlueResinCoffeeTable.webp', alt: 'Huon pine with 2 different blue resin coffee table' }, 
    { src: 'timberClocksAndBowl.webp', alt: 'Timber wall clocks, blackheart sassafras & huon pine. Free formed huon pine bowl.' }, 
    { src: 'blackheartSassafrasGreenResinTimberBoard.webp', alt: 'Blackheart sassafras & lime green resin serving board' }, 
    { src: 'blackSassafrasBlueResinTimberClock.webp', alt: 'Blackheart sassafras & resin clock with light' }, 
    { src: 'myrtleCoffeeTable.webp', alt: 'Myrtle coffee table' }, 
    { src: 'huonPineBlueResinTimberClock.webp', alt: 'Huon pine & resin clock with light' }, 
    { src: 'twoHuonPineGreenResinCoffeeTables.webp', alt: 'Huon pine & green resin coffee table' }, 
    { src: 'huonPineGreenResinCoffeeTable.webp', alt: 'Huon pine & green resin coffee table' },
    { src: 'blackheartSassafrasTimberClock.webp', alt: 'Blackheart sassafras clock' }, 
    { src: 'huonPineDarkBlueResinCoffeeTable.webp', alt: 'Huon pine & dark blue resin coffee table' }, 
    { src: 'huonPineMidBlueResinCoffeeTable.webp', alt: 'Huon pine & mid blue coffee table' },
    { src: 'timberResinLamps.webp', alt: 'Timber & resin colour changing lamps' }, 
    { src: 'timberResinLamps2.webp', alt: 'Timber & resin colour changing lamps' },
    { src: 'blackheartSassafrasLightBlueResinTimberLamp.webp', alt: 'Timber & resin colour changing lamp' },
    { src: 'blackwoodBlackResinDiningTable.webp', alt: 'Blackwood & resin 3 metre dining table' }, 
    { src: 'blackheartSassafrasBlueResinOccasionalTable.webp', alt: 'Blackheart sassafras & resin occasional table' }, 
    { src: 'huonPineBlueResinOccasionalTable.webp', alt: 'Huon pine & resin occasional table' },
    { src: 'huonPineBlueResinServingBoard.webp', alt: 'Huon pine & resin serving board' }, 
    { src: 'huonPineBlueResinTimberClock2.webp', alt: 'Huon pine & resin wall clock' }, 
    { src: 'huonPineBlueResinTimberClock3.webp', alt: 'Huon pine & resin wall clock' },
    { src: 'huonPineBlueResinTimberBoard2.webp', alt: 'Huon pine & resin medium serving board' }, 
    { src: 'huonPineGreenResinTimberBoard.webp', alt: 'Huon pine & resin small serving board' }, 
    { src: 'huonPinePurpleResinTimberTray.webp', alt: 'Huon pine & resin large serving tray' },
    { src: 'huonPineBlueResinTimberBoard3.webp', alt: 'Huon pine & resin medium serving board' }, 
    { src: 'huonPinePurpleResinTimberBoard.webp', alt: 'Huon pine & resin medium serving board' }, 
    { src: 'huonPineBlueResinLazySusan.webp', alt: 'Huon pine & resin medium lazy susan' },
    { src: 'huonPineServingPaddles.webp', alt: 'Huon pine serving paddles with bowl' }, 
    { src: 'blackheartSassafrasGreenResinLazySusan.webp', alt: 'Blackheart sassafras & resin extra large lazy susan' }, 
    { src: 'huonPineDarkBlueResinTimberClock.webp', alt: 'Huon pine & resin clock with gun shells inlaid' },
    { src: 'blackheartSassafrasBlueResinCoffeeTable.webp', alt: 'Blackheart sassafras & resin waterfall coffee table, end view' }, 
    { src: 'blackheartSassafrasBlueResinCoffeeTable2.webp', alt: 'Blackheart sassafras & resin waterfall coffee table, view from other end' }, 
    { src: 'huonPineBlueResinCoffeeTable5.webp', alt: 'Huon pine & resin 4 seater dining table' },
    { src: 'birdseyeKingBillyCoffeeTable.webp', alt: 'Birdseye King Billy coffee table' }, 
    { src: 'timberBreadKnives.webp', alt: 'Timber bread knives' },
  ];

  const [visibleImages, setVisibleImages] = useState(9);
  const [showMore, setShowMore] = useState(true);
  const [b1Hovered, setB1Hovered] = useState(false);
  const galleryRef = useRef(null); // Create a ref for the component

  const handleShowMore = () => {
    setVisibleImages(allImages.length);
    setShowMore(false);
  };

  const handleShowLess = () => {
    setVisibleImages(9);
    setShowMore(true);

    if (galleryRef.current) {
      window.scrollTo({
        top: galleryRef.current.offsetTop,
      });
    }
  };

  const imageStyle = {
    width: "100%",
    height: "auto",
    borderRadius: "1em 1em 0em 0em",
  };

  const buttonStyle = {
    backgroundColor: "transparent",
    color: "#92A082",
    fontWeight: "normal",
    borderBottom: "solid 0.1em #92A082",
    borderRadius: "0em",
  };

  const buttonStyleHover = {
    backgroundColor: "transparent",
    color: "#92A082",
    fontWeight: "bold",
    borderBottom: "solid 0.2em #92A082",
    transition: "color 1s ease, border-bottom-color 1s ease",
    borderRadius: "0em",
  };

  const pWhiteStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
    fontSize: "1.1em",
    lineHeight: "1.4em",
    textAlign: "center",
    padding: "1em 1em 1em 1em",
  };

  const containerStyle = {
    backgroundColor: "#92A082",
    borderRadius: "1em",
  };

  return (
    <div ref={galleryRef}>
      <Grid doubling centered container columns={3}>
        {allImages.slice(0, visibleImages).map((image, index) => (
          <GridColumn key={index}>
            <Container style={containerStyle}>
              <Image 
                src={image.src} 
                alt={image.alt} 
                title={image.alt}
                srcSet={`${image.src} 320w, ${image.src} 768w, ${image.src} 1200w`}
                sizes="(max-width: 600px) 480px, (max-width: 1200px) 800px, 1200px"
                style={imageStyle} 
                loading="lazy"
              />
              <p style={pWhiteStyle} aria-hidden="false">{image.alt}</p>
            </Container>
          </GridColumn>
        ))}
      </Grid>
      <div style={{ textAlign: 'center', marginTop: '2em' }}>
        {showMore ? (
          <Button
            content="Show More" 
            aria-label="Show more images"
            onClick={handleShowMore} 
            onMouseEnter={() => setB1Hovered(true)}
            onMouseLeave={() => setB1Hovered(false)}
            style={b1Hovered ? buttonStyleHover : buttonStyle}
          />
        ) : (
          <Button 
            content="Show Less" 
            aria-label="Show fewer images" 
            onClick={handleShowLess}
            onMouseEnter={() => setB1Hovered(true)}
            onMouseLeave={() => setB1Hovered(false)}
            style={b1Hovered ? buttonStyleHover : buttonStyle}
          />
        )}
      </div>
    </div>
  );
}
